<template>

  <div class="menu-button" :class="{ open: open }" @click="toggle">
    <span class="top"></span>
    <span class="middle"></span>
    <span class="bottom"></span>
    <div class="close-menu"></div>
  </div>

</template>

<script>

  export default {

    data() {
      return {
        open: false
      }
    },

    methods: {
      toggle(){
        this.open = !this.open;
        document.body.classList.toggle('drawer-open');
      }
    }

  }

</script>